import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { Textarea } from '@/components/common/form/textarea'
import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form'
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { useGetCallDetails } from '../../hooks/use-call-details'
import { ChamadoService } from '../../services/chamado.service'

interface Props {
  callId: number
  initialDescription: string
  disabled?: boolean
  onSuccess: (data: any) => void
}

type FormValues = { description: string }

function EditForm({ callId, initialDescription, onSuccess }: Props) {
  const { invalidateCallDetails } = useGetCallDetails(callId)

  const form = useForm<FormValues>({
    defaultValues: { description: '' },
  })

  useEffect(() => {
    form.reset({ description: initialDescription })
  }, [initialDescription])

  const cancelHandler = form.handleSubmit(async ({ description }) => {
    if (!description) return

    try {
      const res = await ChamadoService.cancel({
        id: callId,
        cancelDescription: description,
      })
      onSuccess(res)
      invalidateCallDetails()
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  })

  const closeHandler = form.handleSubmit(async ({ description }) => {
    if (!description) return

    try {
      const res = await ChamadoService.end({
        id: callId,
        clientDescription: description,
      })
      onSuccess(res)
      invalidateCallDetails()
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  })

  return (
    <Form {...form}>
      <form className="flex h-full flex-col">
        <SheetHeader>
          <SheetTitle>Encerrar chamado</SheetTitle>
        </SheetHeader>

        <div className="flex-1 py-4">
          <Textarea
            field_control={form.control}
            field_name="description"
            field_label="Descrição"
          />
        </div>

        <SheetFooter className="sm:justify-between">
          <Button variant="destructive" onClick={cancelHandler}>
            Cancelar
          </Button>
          <Button onClick={closeHandler}>Encerrar</Button>
        </SheetFooter>
      </form>
    </Form>
  )
}

export default function Component({ disabled, ...props }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button disabled={disabled}>Encerrar</Button>
      </SheetTrigger>

      <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
        <EditForm
          {...props}
          onSuccess={(res) => {
            setIsOpen(false)
            props.onSuccess(res)
          }}
        />
      </SheetContent>
    </Sheet>
  )
}
